<template>
  <div class="calico-global-navigation">
    <CalicoNavbar
      ref="navbar"
      @menu="$emit('drawer')"
      @search="showSearchDialog = true"
      @settings="showSettings = !showSettings"
      @redirect="() => $router.push(logoLink)"
    />

    <SearchDialog
      v-if="showSearchDialog"
      @close="showSearchDialog = false"
    />

    <UsageDialog
      v-if="showUsageDialog"
      :usage="usage"
      :loading="usageLoading"
      :error-message="usageError"
      @close="showUsageDialog = false"
    />

    <div class="menu-container">
      <CalicoNavbarMenu v-if="showSettings">
        <CalicoNavbarMenuItem
          v-if="isRepresentative"
          @click="handleViewUsage"
        >
          <i class="bi bi-speedometer2" />
          <span class="body--medium">View Usage</span>
        </CalicoNavbarMenuItem>

        <CalicoNavbarMenuItem
          @click="handleUserSettings"
        >
          <i class="bi bi-person-fill" />
          <span class="body--medium">User Settings</span>
        </CalicoNavbarMenuItem>

        <CalicoNavbarMenuItem @click="openContactUs">
          <i class="bi bi-life-preserver" />
          <span class="body--medium">Contact Us</span>
        </CalicoNavbarMenuItem>

        <CalicoNavbarMenuItem @click="handleLogout">
          <i class="bi bi-box-arrow-in-right" />
          <span class="body--medium">Log out</span>
        </CalicoNavbarMenuItem>
      </CalicoNavbarMenu>
    </div>
  </div>
</template>

<script>
import CalicoNavbar from "@/components/calico/navbar/index.vue";
import SearchDialog from "@/components/pattern/searchDialog/index.vue";
import CalicoNavbarMenu from "@/components/calico/navbarMenu/index.vue";
import CalicoNavbarMenuItem from "@/components/calico/navbarMenuItem/index.vue";
import UsageDialog from "@/components/pattern/usageDialog/index.vue";
import services from "@/services";

export default {
  name: "CalicoGlobalNavigation",

  components: {
    CalicoNavbar,
    SearchDialog,
    CalicoNavbarMenu,
    CalicoNavbarMenuItem,
    UsageDialog,
  },

  data() {
    return {
      showSearchDialog: false,
      showSettings: false,
      showUsageDialog: false,

      isRepresentative: false,

      usage: null,
      usageLoading: false,
      usageError: ""
    };
  },

  async mounted() {
    try {
      const user = await services.user.get();
      this.isRepresentative = user?.role?.name === "Representative";
    } catch {
      this.isRepresentative = false;
    }
  },

  methods: {
    async handleLogout() {
      await this.$auth.signOut();
      localStorage.removeItem("recentSearches");
      this.$router.push("/login");
    },

    async handleViewUsage() {
      if (!this.isRepresentative) return;

      this.showSettings = false;
      this.showUsageDialog = true;

      this.usageError = "";
      this.usage = null;
      this.usageLoading = true;

      try {
        const res = await services.usage.getCurrentUsage();
        this.usage = res || null;
      } catch (e) {
        this.usageError = "Failed to load usage.";
        this.usage = null;
      } finally {
        this.usageLoading = false;
      }
    },

    async handleUserSettings() {
      this.$router.push("/settings");
    },
    
    openContactUs() {
      window.open("https://www.betascore.ai/contact-us", "_blank", "noopener");
    }
  }
};
</script>

<style scoped lang="scss">
.calico-global-navigation {
  display: flex;
  position: relative;
  width: 100%;
  justify-content: center;

  .menu-container {
    display: flex;
    position: absolute;
    top: 100%;
    width: 100%;
    max-width: $large-screen-max-width;
    justify-content: flex-end;
    z-index: $z-index-dialog;
    border-radius: $radius-small;
  }
  .user-settings-content {
    @include stack-space($space-small);
    @include inset-space($space-large);
    text-align: center;
  }
}
</style>